import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import { LineInput } from "components/Inputs/LineInput";

import LabeledToggle from "components/Inputs/Toggle/Toggle";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import warningIconRed from "images/triangle-exclamation-red.svg";

import { useDispatch, useSelector } from "types/store";
import * as languageModelArtifactReducer from "containers/LanguageModelArtifact/reducer";

import { MODELS } from "containers/ChatGPT/reducer";

import moment from "moment";

import styles from "./style.module.css";

const ProvisionedLLMButtonTile = ({ llm, getLogo, handleClick, provisioning, fineTuning } = {}) => {
  const [enabled, updateEnabled] = useState(llm?.enabled);

  const fineTuneDataList = useSelector((state) => languageModelArtifactReducer.getFineTuningDataList(state)) ?? [];

  const modelIsReady = llm?.metadata?.status === "COMPLETE";
  const modelError = llm?.metadata?.status === "ERROR";
  const modelInProgress = llm?.metadata?.status === "INPROGRESS";

  const baseModelName =
    llm?.metadata?.base_model_id === "mistral"
      ? "Mistral AI"
      : llm?.metadata?.base_model_id === MODELS.GOOGLE
        ? "Google PaLM 2"
        : String(llm?.metadata?.base_model_id);

  const modelDataset = fineTuneDataList?.find((a) => a?.id === llm?.metadata?.fine_tuning_data_id);

  return (
    <div
      className={
        fineTuning
          ? modelIsReady
            ? styles.llmButtonTile
            : styles.llmButtonTileDisabled
          : provisioning
            ? enabled
              ? styles.llmButtonTile
              : styles.llmButtonTileDisabled
            : styles.llmButtonTileDisabled
      }
      onClick={() => handleClick(llm)}
    >
      <div className={styles.llmButtonInfo}>
        <div className={styles.provisionedLlmHeader}>
          <div className={styles.provisionedLogoWrapper}>
            <img src={getLogo(llm?.metadata?.base_model_id ?? llm?.id)} className={styles.provisionedLlmLogo} />
          </div>
          <div>{llm?.name}</div>
        </div>
        <div className={styles.provisionedMetaInfo}>
          <div>{moment.utc(llm?.created_date).local().fromNow()}</div>
          <div>{`ADDED BY: ${llm?.created_by?.fullname}`}</div>
        </div>
        <div className={styles.provisionedInfoWrapper}>
          {provisioning && <div>{llm?.description}</div>}
          {fineTuning && (
            <div>
              <div className={styles.fineTuningInfoItem}>
                <div className={styles.fineTuningInfoLabel}>{"Base Model: "}</div>
                <div className={styles.fineTuningBoldLabel}>{baseModelName}</div>
              </div>
              {llm?.metadata?.fine_tuning_data_id > 0 ? (
                <div className={styles.fineTuningInfoItem}>
                  <div className={styles.fineTuningInfoLabel}>{"Fine-Tuned with: "}</div>
                  <div className={styles.fineTuningBoldLabel}>{modelDataset?.name}</div>
                </div>
              ) : (
                <div className={styles.fineTuningInfoItem}>
                  <div className={styles.fineTuningInfoLabel}>{"Custom Model"}</div>
                </div>
              )}
            </div>
          )}
          {modelInProgress && fineTuning && (
            <div className={styles.tuningProgressWrapper}>
              <LoadingIndicator
                style={{
                  transform: "scale(0.40)",
                  width: "53px",
                  height: "27px",
                  margin: "-12px 0px 0px -18px"
                }}
              />
              {"Fine Tuning in progress"}
            </div>
          )}
          {modelError && (
            <div className={styles.tuningProgressWrapper}>
              <div className={styles.iconWrapper}>
                <img src={warningIconRed} />
              </div>
              <div className={styles.errorText}>{"Fine Tuning Failed"}</div>
            </div>
          )}
        </div>
      </div>
      {provisioning && llm?.metadata?.status === "COMPLETE" && (
        <div className={styles.llmButtonFooter}>
          <div className={styles.toggleWrapper} onClick={(e) => e.stopPropagation()}>
            <LabeledToggle
              style={{ display: "block", marginRight: "8px" }}
              checked={enabled}
              onChange={(e) => {
                e.stopPropagation();
                updateEnabled(!enabled);
              }}
              isAibleColors
            />
            {"Enabled"}
          </div>
        </div>
      )}
    </div>
  );
};

export default ProvisionedLLMButtonTile;
